import { CUSTOM_CHAINS } from './custom-chain.constants';
import bnbIcon from '../assets/images/icons/bnb-icon.svg';
import baseIcon from '../assets/images/icons/eth-icon.svg';
import stellarIcon from '../assets/images/stellar-logo.png';
import { getImageUrl } from '../helpers/image.helpers';

export const IMAGE_BY_CHAIN = {
  [CUSTOM_CHAINS.BNB]: getImageUrl(bnbIcon),
  [CUSTOM_CHAINS.BASE]: getImageUrl(baseIcon),
  [CUSTOM_CHAINS.STELLAR]: getImageUrl(stellarIcon),
};
